import { useT } from '_metronic/i18n/Metronici18n'
import { IconPaths, ModalSize } from '../../../../../../../_metronic/helpers'
import { Button, useModal } from '../../../../../../components'
import { RiscoClienteModal } from '../modal/RiscoClienteModal'

export const RiscoClienteListToolbar = () => {
  const { showModal } = useModal()
  const { t } = useT()

  const openAddRisco = () => {
    showModal({ title: 'Risco', content: <RiscoClienteModal />, size: ModalSize.Medium })
  }

  return (
    <Button className='btn-primary' icon={IconPaths.Add} onClick={openAddRisco}>
      {t('common.add')}
    </Button>
  )
}
